import { SESSION_COOKIE_NAME } from '@/constants/cookies';

const ONE_WEEK_SECONDS = 60 * 60 * 24 * 7;

/** Path / SameSite; add Secure when the page is HTTPS (sane defaults behind TLS / Nginx). */
function sessionCookieAttributes(): string {
  if (typeof window === 'undefined') {
    return '; Path=/; SameSite=Lax';
  }
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  return `; Path=/; SameSite=Lax${secure}`;
}

/**
 * Coarse routing hint for middleware — not a substitute for API authorisation.
 * Pair with HttpOnly cookies via a BFF when moving beyond SPA-local persistence.
 */
export function syncSessionCookie(hasSession: boolean): void {
  if (typeof document === 'undefined') {
    return;
  }

  const attrs = sessionCookieAttributes();

  if (hasSession) {
    document.cookie = `${SESSION_COOKIE_NAME}=1; Max-Age=${ONE_WEEK_SECONDS}${attrs}`;
    return;
  }

  document.cookie = `${SESSION_COOKIE_NAME}=; Max-Age=0${attrs}`;
}
